let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5Ck3F")).then(() => parcelRequire('LAKPi'));